import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createSlots as _createSlots } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "login_popup_input" }
const _hoisted_3 = { class: "custom-label" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "require"
}
const _hoisted_6 = {
  key: 1,
  class: "no-require"
}
const _hoisted_7 = {
  key: 0,
  class: "error-message"
}

import { computed, inject, ref, watch } from 'vue'
import { useI18n } from 'vue3-i18n'
import { MinusOutlined } from '@ant-design/icons-vue'
import {
  formatPhoneNumber,
  formatPolicyAndBranchNo,
  convertToHalfWidth,
  formatDigitOnly,
  formatZipCode,
  formatPhNo
} from '../utils/newUtils/FormatUtils'
import { useStore } from 'vuex'


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonInput',
  props: {
  name: { type: String },
  time: { type: String },
  label: { type: String, default: '' },
  placeholder: { type: String, default: '' },
  maxlength: { type: Number },
  type: { type: String, default: '' },
  disabled: { type: Boolean },
  readOnly: { type: Boolean },
  value: { type: [String, Number], default: '' },
  colSpan: { type: String },
  colLabel: { type: String },
  required: { type: Boolean, default: false },
  onchange: { type: Function },
  showImg: { type: Boolean },
  srcImg: { type: String },
  onChangeImg: { type: Function },
  messageError: { type: String, default: '' },
  imgName: { type: String },
  removed: { type: Boolean, default: false },
  isLinkLabel: { type: Boolean, default: false },
  hyperlink: { type: String },
  isCustomInput: { type: Boolean, default: false },
  shortFormInput: { type: Boolean, default: false },
  searchPopUp: { type: Boolean, default: false },
  widthForm: { type: Boolean, default: false },
  isZipCode: { type: Boolean, default: false },
  isPhoneNumber: { type: Boolean, default: false },
  isPolicyAndBranchNo: { type: Boolean, default: false },
  isNumberPlate: { type: Boolean, default: false },
  isReportingParty: { type: Boolean, default: false },
  isReportingPartyPhone: { type: Boolean, default: false },
  inputFieldErrorMsg: { type: String, default: '' },
  isError: { type: Boolean, default: false },
  isValid: { type: Boolean, default: false },
  allowClear: { type: Boolean, default: true },
  ignoreLock: { type: Boolean, default: false },
  isAge: { type: Boolean, default: false },
  title: { type: String, default: '' }
},
  emits: ['update:value', 'remove-item', 'blur', 'input'],
  setup(__props, { emit: __emit }) {

_useCssVars(_ctx => ({
  "7717d906": (_unref(alignDyn)),
  "7760ff4e": (_unref(marginDyn)),
  "610bd22e": (marginBottomDyn.value),
  "842982b6": (_unref(widthDyn))
}))

const props = __props

const inputValue = ref(props.value) // Use a local ref for inputValue
const i18n = useI18n()
const store = useStore()
const language = localStorage.getItem('lang') || i18n.getLocale()

const searchPopUp = ref(props.searchPopUp)
const widthForm = ref(props.widthForm)
const marginBottomDyn = ref('')
const emits = __emit
const isLock = inject('isLock', false)
const isAgencyThirdView = inject('isAgencyThirdView', false)
const currentLocale = computed(() => store.getters['common/getCurrentLocale'])
const widthDyn = searchPopUp.value && widthForm.value ? '16.5%' : '50%'
const alignDyn = searchPopUp.value ? 'flex-end' : 'flex-start'
const marginDyn = searchPopUp.value ? '20px' : '0px'
const inputErrorMessage = ref(!props.isError)
const handleChange = (event: any) => {
  const inputValue = (event.target as HTMLInputElement).value
  let maskedValue = ''
  if (props.isZipCode) {
    maskedValue = formatZipCode(inputValue)
    event.target.value = maskedValue
  } else if (props.isPhoneNumber) {
    let outputDigit = formatDigitOnly(inputValue)
    // Maximum 14 DIGITS, excluding "-"
    outputDigit = outputDigit.slice(0, 14)
    maskedValue = outputDigit.length > 0 ? formatPhoneNumber(outputDigit) : outputDigit
    if (
      !maskedValue &&
      event.inputType !== 'deleteContentBackward' &&
      event.pointerType !== 'mouse'
    ) {
      inputErrorMessage.value = true
    } else {
      inputErrorMessage.value = false
    }
    event.target.value = maskedValue
  } else if (props.isPolicyAndBranchNo) {
    const outputDigit = formatPolicyAndBranchNo(formatDigitOnly(inputValue))
    maskedValue = outputDigit.length > 0 ? formatPhoneNumber(outputDigit) : outputDigit
    if (
      !maskedValue &&
      event.inputType !== 'deleteContentBackward' &&
      event.pointerType !== 'mouse'
    ) {
      inputErrorMessage.value = true
    } else {
      inputErrorMessage.value = false
    }
    event.target.value = maskedValue
    event.target.value = maskedValue
  } else if (props.isNumberPlate) {
    maskedValue = convertToHalfWidth(inputValue)
  } else if (props.isReportingParty) {
    maskedValue = convertToHalfWidth(inputValue)
  } else if (props.isReportingPartyPhone) {
    maskedValue = convertToHalfWidth(inputValue)
  } else if (props.isAge) {
    maskedValue = formatDigitOnly(inputValue).slice(0, 3)
    event.target.value = maskedValue
  } else {
    maskedValue = inputValue
  }
  emits('update:value', maskedValue)
  emits('input', event)
}

const removeValue = () => {
  inputValue.value = ''
  inputErrorMessage.value = false
  emits('update:value', '') // Ensure the value is also cleared in the parent component
  emits('remove-item') // Emit a custom event to indicate item removal
}

const handleBlur = () => {
  emits('blur')
}
watch(
  () => props.value,
  (newValue) => {
    inputValue.value = newValue
  }
)
watch(props, () => {
  if (props.isError) inputErrorMessage.value = false
})
const noLabelInputClass = (locale: string) => {
  if (locale === 'ja') {
    marginBottomDyn.value = '4px'
  } else if (locale === 'en') {
    marginBottomDyn.value = '-1px'
  }
}

noLabelInputClass(language)

watch(
  () => i18n.getLocale(),
  (newLocale) => {
    // console.log('Locale changed to:', newLocale)
    noLabelInputClass(newLocale)
  }
)

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    (__props.isCustomInput)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", _hoisted_3, _toDisplayString(__props.label), 1),
            _createVNode(_component_a_input, {
              class: _normalizeClass(["ant-input-custom", __props.required === true ? 'ant-required' : '']),
              value: __props.value,
              placeholder: __props.placeholder,
              type: __props.type,
              maxlength: __props.maxlength,
              disabled: __props.disabled,
              onBlur: handleBlur,
              onInput: handleChange,
              readOnly: __props.readOnly || _unref(isAgencyThirdView),
              "allow-clear": false,
              title: __props.title
            }, null, 8, ["class", "value", "placeholder", "type", "maxlength", "disabled", "readOnly", "title"])
          ])
        ]))
      : _createCommentVNode("", true),
    (!__props.isCustomInput)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_a_row, { type: "flex" }, {
            default: _withCtx(() => [
              (__props.label && __props.isLinkLabel)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 0,
                    span: __props.colLabel,
                    class: "custom-label"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", null, [
                        _createElementVNode("u", null, _toDisplayString(__props.label), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["span"]))
                : (__props.label)
                  ? (_openBlock(), _createBlock(_component_a_col, {
                      key: 1,
                      style: {"padding-bottom":"7px"},
                      span: __props.colLabel,
                      class: "custom-label"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.label), 1)
                      ]),
                      _: 1
                    }, 8, ["span"]))
                  : (_openBlock(), _createBlock(_component_a_col, {
                      key: 2,
                      span: __props.colLabel,
                      class: "custom-no-label",
                      style: _normalizeStyle({ height: currentLocale.value === 'en' ? '' : '12px' })
                    }, null, 8, ["span", "style"])),
              _createVNode(_component_a_col, {
                span: __props.colSpan,
                style: {"display":"inherit","width":"100%"}
              }, {
                default: _withCtx(() => [
                  (__props.required === true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.require), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6)),
                  _createVNode(_component_a_form_item, {
                    rules: [{ required: __props.required, message: __props.messageError }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        class: _normalizeClass(["ant-input-custom", [
                __props.shortFormInput === true ? 'short_form_input' : '',
                __props.disabled ? 'ant-input-custom-disabled' : '',
                __props.isValid ? 'ant-input-custom-valid' : ''
              ]]),
                        title: __props.title,
                        name: __props.name,
                        value: __props.value,
                        placeholder: __props.placeholder,
                        type: __props.type,
                        onBlur: handleBlur,
                        maxlength: __props.maxlength,
                        disabled: __props.disabled,
                        onInput: handleChange,
                        "allow-clear": false,
                        readOnly: __props.ignoreLock ? false : __props.readOnly || _unref(isLock) || _unref(isAgencyThirdView)
                      }, _createSlots({ _: 2 }, [
                        (__props.removed)
                          ? {
                              name: "suffix",
                              fn: _withCtx(() => [
                                _createVNode(_component_a_tooltip, { onClick: removeValue }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(MinusOutlined))
                                  ]),
                                  _: 1
                                })
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1032, ["class", "title", "name", "value", "placeholder", "type", "maxlength", "disabled", "readOnly"]),
                      (inputErrorMessage.value && __props.isError)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t(__props.inputFieldErrorMsg)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["rules"])
                ]),
                _: 1
              }, 8, ["span"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})